import React, { useEffect, useState } from 'react'
import CustomRadioButton from '../../Util/CustomRadioButton/CustomRadioButton'
import { useTranslation } from 'react-i18next';
import useFilters from '../../../hooks/useFilters';
import { trackActionClicked } from '../../../api/trackActionClickedApi';
import { TrackedActions } from '../../../models/TrackedActionsEnum';

export const DisbursementDataFilter = () => {
  const { filter, dispatch, setFilter } = useFilters();
  const [disbursementType, setDisbursementType] = useState(filter.common.isAnnual || 'accumulated');
  const { t } = useTranslation();

  useEffect(() => {
    setDisbursementType(filter.common.isAnnual || 'accumulated');
  }, [filter.common.isAnnual])
  

  const handleDisbursementTypeChange = (value: string) => {
    dispatch(
      setFilter({
        ...filter,
        common: {
          ...filter.common,
          isAnnual: value,
        },
      }),
    );

    if (value === 'accumulated') {
      trackActionClicked(TrackedActions.disbursementDataAccumulated);
    } else {
      trackActionClicked(TrackedActions.disbursementDataAnnual);
    }
  };

  return (
    <div style={{ display: 'flex', gap: '48px', alignItems: 'center', height: '100%' }}>
      <CustomRadioButton
        customStyle={{ paddingLeft: 24,  fontWeight: 400, lineHeight: '17px', flex: '1 1', color: '#424D64', fontSize: '16px' }}
        customChecked={{ checked: 'selected-checked', unchecked: 'unchecked' }}
        labelText={t('disbursement_data_accumulated')}
        handleOnClick={() => handleDisbursementTypeChange('accumulated')}
        isChecked={disbursementType === 'accumulated'}
      />
      <CustomRadioButton
        customStyle={{ paddingLeft: 24,  fontWeight: 400, lineHeight: '17px', flex: '1 1', color: '#424D64', fontSize: '16px' }}
        customChecked={{ checked: 'selected-checked', unchecked: 'unchecked' }}
        labelText={t('disbursement_data_annual')}
        handleOnClick={() => handleDisbursementTypeChange('annual')}
        isChecked={disbursementType === 'annual'}
      />
    </div>
  )
}
